import { FirestoreSharedKeys } from "shared/firestore";
import { IApplication } from "shared/model/IApplication";
import { ICoworkBranch, ICoworkSpace } from "shared/model/ICoworkSpace";

import { createObjectsMap } from "../../model/SharedTypes";
import { IApplicationsState } from "./applications";

export default class ApplicationsReducers {
  public static reloadingApplications = (
    state: IApplicationsState,
    params: {
      currentUserCoworkBranch?: ICoworkBranch;
    }
  ): IApplicationsState => ({
    ...state,
    applicationsForCurrentCowork: {
      isFetching: true,
      ids: []
    },
    currentCoworkBranch: params.currentUserCoworkBranch
  });

  public static reloadApplicationsSucceeded = (
    state: IApplicationsState,
    params: {
      coworkingSpace: ICoworkSpace;
      applications: IApplication[];
      currentUserCoworkBranch: ICoworkBranch;
      branches: ICoworkBranch[];
    }
  ): IApplicationsState => {
    return {
      ...state,
      branches: params.branches.sort(ApplicationsReducers.sortBranches),
      currentCoworkSpace: params.coworkingSpace,
      currentCoworkBranch: params.currentUserCoworkBranch,
      applicationsForCurrentCowork: {
        isFetching: false,
        ids: params.applications.map(app => app.uid!)
      },
      applications: createObjectsMap<IApplication>(params.applications)
    };
  };

  public static reloadApplicationsFailed = (
    state: IApplicationsState,
    error: string
  ): IApplicationsState => ({
    ...state,
    applicationsForCurrentCowork: {
      isFetching: false,
      ids: [],
      error
    }
  });

  public static applicationsUpdate = (
    state: IApplicationsState,
    params: {
      applications: IApplication[];
    }
  ): IApplicationsState => {
    return {
      ...state,
      applications: createObjectsMap<IApplication>(params.applications)
    };
  };

  public static creatingApplication = (
    state: IApplicationsState
  ): IApplicationsState => ({
    ...state,
    creation: {
      inProgress: true
    },
    lastCreatedApplicationId: undefined
  });
  public static createApplicationSucceeded = (
    state: IApplicationsState,
    params: {
      application: IApplication;
    }
  ): IApplicationsState => ({
    ...state,
    creation: undefined,
    applications: {
      ...state.applications,
      [params.application.uid!]: params.application
    },
    applicationsForCurrentCowork: {
      ...state.applicationsForCurrentCowork,
      ids: [params.application.uid!, ...state.applicationsForCurrentCowork.ids]
    },
    lastCreatedApplicationId: params.application.uid
  });
  public static createApplicationFailed = (
    state: IApplicationsState,
    error: string
  ): IApplicationsState => ({
    ...state,
    creation: {
      inProgress: false,
      error
    }
  });

  private static sortBranches = (
    first: ICoworkBranch,
    second: ICoworkBranch
  ): number => {
    if (first.name === FirestoreSharedKeys.DefaultBranchName) {
      return -1;
    } else if (second.name === FirestoreSharedKeys.DefaultBranchName) {
      return 1;
    } else {
      return first.name > second.name ? 1 : -1;
    }
  };
}



// WEBPACK FOOTER //
// ./src/state/modules/applications/ApplicationsReducers.ts